import axios from "axios";
import { useEffect, useState } from "react";

// Mídias extras dos produtos (fotos e vídeo) para as telas do cliente: cardápio,
// Mesa QR e Totem. Uma chamada só, guardada por 5 minutos: o Totem fica
// aberto o dia inteiro e precisa enxergar vídeo novo sem recarregar a página.
const VALIDADE_MS = 5 * 60 * 1000;
const VAZIO = {};
let cache = null;
let cacheEm = 0;
let pedido = null;

export const urlMidia = (url) => {
  if (!url) return null;
  if (/^https?:\/\//.test(url)) return url;
  return url.startsWith("/uploads/") ? `/api${url}` : url;
};

export function carregarMidias() {
  if (cache && Date.now() - cacheEm < VALIDADE_MS) return Promise.resolve(cache);
  if (!pedido) {
    pedido = axios.get("/api/public/products/midias")
      .then((r) => {
        const d = r.data && Object.keys(r.data).length ? r.data : VAZIO;
        cache = d; cacheEm = Date.now(); pedido = null;
        return d;
      })
      .catch(() => { pedido = null; return cache || VAZIO; });
  }
  return pedido;
}

/** {product_id: [{tipo, url, poster?}]} — vazio enquanto carrega ou se falhar. */
export function useMidiasPublicas(ativo = true) {
  const [mapa, setMapa] = useState(cache || VAZIO);
  useEffect(() => {
    if (!ativo) return undefined;
    let vivo = true;
    // Mesmo objeto (ou loja sem mídia) → não re-renderiza o cardápio inteiro
    carregarMidias().then((m) => vivo && setMapa((atual) => (atual === m ? atual : m)));
    return () => { vivo = false; };
  }, [ativo]);
  return mapa;
}

/** Vídeo só quando faz sentido: sem economia de dados e sem "reduzir movimento". */
export function podeTocarVideo() {
  try {
    if (navigator.connection?.saveData) return false;
    if (/(^|-)2g$/.test(navigator.connection?.effectiveType || "")) return false;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return false;
  } catch { /* navegador antigo: deixa tocar */ }
  return true;
}
